export const PRODUCT_TABLE_HEAD = [
  { id: 'name', label: 'Name', alignRight: false },
  { id: 'product_id', label: 'Id', alignRight: false },
  { id: '' },
];
